(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(84216);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69498);



var ReCaptchaWrapper = function(param) {
    var children = param.children, recaptchaActive = param.recaptchaActive, recaptchaKey = param.recaptchaKey;
    if (!+recaptchaActive) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__/* .ReCaptchaProvider */ .dR, {
        useEnterprise: true,
        reCaptchaKey: recaptchaKey,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReCaptchaWrapper);


/***/ }),

/***/ 84216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./components/blocks/BlockSlideShow.module.scss
var BlockSlideShow_module = __webpack_require__(66445);
var BlockSlideShow_module_default = /*#__PURE__*/__webpack_require__.n(BlockSlideShow_module);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
;// CONCATENATED MODULE: ./components/ForCWV/Slider.tsx







var settings = {
    arrows: false,
    dots: true,
    infinite: true,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 8000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: "linear"
};
var SliderComponent = function(param) {
    var sliders = param.slider.sliders, dbName = param.dbName, translationsData = param.translationsData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (BlockSlideShow_module_default()).home_slide_container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                children: sliders.map(function(param, index) {
                    var realPath = param.path, altTitle = param.title, dangerouslyContent = param.content, settingForImg = param.settings, slider_path = param.slider_path;
                    var buttonHandler = {
                        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (BlockSlideShow_module_default())["block-slideshow__slide-button"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return window.open(slider_path, "_blank");
                                },
                                className: "btn btn-orange ".concat((BlockSlideShow_module_default())["slideshow-btn"]),
                                children: translationsData.SliderButtonTitle
                            })
                        }),
                        false: null
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlockSlideShow_module_default())["block-slideshow__slide"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BlockSlideShow_module_default()).slider_image_wrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
                                    src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(realPath)),
                                    alt: altTitle
                                }, settingForImg))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BlockSlideShow_module_default())["block-slideshow__slide-content"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (BlockSlideShow_module_default())["block-slideshow__slide-title"],
                                    dangerouslySetInnerHTML: {
                                        __html: dangerouslyContent
                                    }
                                })
                            }),
                            buttonHandler["".concat(!!slider_path)]
                        ]
                    }, index);
                })
            }))
        })
    });
};
/* harmony default export */ var Slider = (SliderComponent);

// EXTERNAL MODULE: ./components/home/homePage.module.scss
var homePage_module = __webpack_require__(67157);
var homePage_module_default = /*#__PURE__*/__webpack_require__.n(homePage_module);
;// CONCATENATED MODULE: ./components/ForCWV/Heading.tsx



var HomeIntro = function(param) {
    var translationsData = param.translationsData;
    var showWelcomeText = translationsData.HomeHeading !== "empty" || translationsData.HomeIntro !== "empty";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showWelcomeText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (homePage_module_default())["welcome-title"],
                children: [
                    translationsData.HomeHeading !== "empty" && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: translationsData.HomeHeading
                    }),
                    translationsData.HomeIntro !== "empty" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: translationsData.HomeIntro
                    })
                ]
            })
        }) : null
    });
};
/* harmony default export */ var Heading = (HomeIntro);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 31 modules
var MainLayout = __webpack_require__(11416);
// EXTERNAL MODULE: ./components/builder/BuilderDataRender.tsx + 30 modules
var BuilderDataRender = __webpack_require__(30068);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/ForCWV/Products/products.module.scss
var products_module = __webpack_require__(31351);
var products_module_default = /*#__PURE__*/__webpack_require__.n(products_module);
// EXTERNAL MODULE: ./components/ForCWV/Products/BlockHeader/index.tsx
var BlockHeader = __webpack_require__(98503);
// EXTERNAL MODULE: ./components/ForCWV/Products/ProductCard.tsx
var ProductCard = __webpack_require__(84937);
;// CONCATENATED MODULE: ./components/ForCWV/Products/BlockProduct/NewProducts.tsx







var NewProducts = function(_param) {
    var products = _param.products, isMobile = _param.isMobile, showSlider = _param.showSlider, pageProps = (0,_object_without_properties/* default */.Z)(_param, [
        "products",
        "isMobile",
        "showSlider"
    ]);
    var ref, ref1;
    var ref2 = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(false), originalProducts = ref3[0], setOriginalProducts = ref3[1];
    var handleBlockTitle = {
        true: {
            true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader/* default */.Z, {
                    title: (ref = products[0]) === null || ref === void 0 ? void 0 : ref.block_title
                })
            }),
            false: null
        },
        false: {
            true: null,
            false: null
        }
    };
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (ref2 && ref2.current) {
                setOriginalProducts(window.scrollY >= 80);
            }
        };
        if (!originalProducts && isMobile) {
            window.addEventListener("scroll", handleScroll);
        } else {
            window.removeEventListener("scroll", handleScroll);
        }
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container ".concat((products_module_default())["home-product-container"]),
        children: [
            handleBlockTitle["".concat(!!products.length)]["".concat(!!((ref1 = products[0]) === null || ref1 === void 0 ? void 0 : ref1.block_title))],
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (products_module_default())["block-products__body"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (products_module_default())["block-products__list"],
                    children: (isMobile && !originalProducts ? products.filter(function(_, indexFil) {
                        return showSlider === "Slider" ? indexFil < 2 : indexFil < 4;
                    }) : products).map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                minHeight: 200
                            },
                            className: (products_module_default())["product-card-parent"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: !originalProducts ? ref2 : null,
                                className: (products_module_default())["block-products__list-item"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                                    isMobile: true,
                                    product: product,
                                    priority: false,
                                    // priority={isMobile ? index < 2 : index < 4}
                                    // loading={index < 2 ? "eager" : "lazy"}
                                    loading: showSlider === "Slider" ? "lazy" : "eager"
                                }, pageProps))
                            })
                        }, product.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var BlockProduct_NewProducts = (NewProducts);

;// CONCATENATED MODULE: ./components/ForCWV/Products/BlockProduct/FeaturedProducts.tsx







var FeaturedProducts = function(_param) {
    var products = _param.products, isMobile = _param.isMobile, pageProps = (0,_object_without_properties/* default */.Z)(_param, [
        "products",
        "isMobile"
    ]);
    var ref, ref1;
    var ref2 = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(false), originalProducts = ref3[0], setOriginalProducts = ref3[1];
    var handleBlockTitle = {
        true: {
            true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader/* default */.Z, {
                    title: (ref = products[0]) === null || ref === void 0 ? void 0 : ref.block_title
                })
            }),
            false: null
        },
        false: {
            true: null,
            false: null
        }
    };
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (ref2 && ref2.current) {
                var ref;
                setOriginalProducts(window.scrollY >= ((ref = ref2.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - 800);
            }
        };
        if (!originalProducts && isMobile) {
            window.addEventListener("scroll", handleScroll);
        } else {
            window.removeEventListener("scroll", handleScroll);
        }
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container ".concat((products_module_default())["home-product-container"]),
        children: [
            handleBlockTitle["".concat(!!products.length)]["".concat(!!((ref1 = products[0]) === null || ref1 === void 0 ? void 0 : ref1.block_title))],
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (products_module_default())["block-products__body"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (products_module_default())["block-products__list"],
                    children: (isMobile && !originalProducts ? products.filter(function(_, indexFil) {
                        return indexFil < 2;
                    }) : products).map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                minHeight: 200
                            },
                            className: (products_module_default())["product-card-parent"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: !originalProducts ? ref2 : null,
                                className: (products_module_default())["block-products__list-item"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                                    isMobile: true,
                                    product: product,
                                    priority: false,
                                    loading: "lazy"
                                }, pageProps))
                            })
                        }, product.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var BlockProduct_FeaturedProducts = (FeaturedProducts);

;// CONCATENATED MODULE: ./components/ForCWV/Products/BlockProduct/ThirdProducts.tsx







var ThirdProducts = function(_param) {
    var products = _param.products, isMobile = _param.isMobile, pageProps = (0,_object_without_properties/* default */.Z)(_param, [
        "products",
        "isMobile"
    ]);
    var ref, ref1;
    var ref2 = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(false), originalProducts = ref3[0], setOriginalProducts = ref3[1];
    var handleBlockTitle = {
        true: {
            true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader/* default */.Z, {
                    title: (ref = products[0]) === null || ref === void 0 ? void 0 : ref.block_title
                })
            }),
            false: null
        },
        false: {
            true: null,
            false: null
        }
    };
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (ref2 && ref2.current) {
                var ref;
                setOriginalProducts(window.scrollY >= ((ref = ref2.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - 1000);
            }
        };
        if (!originalProducts && isMobile) {
            window.addEventListener("scroll", handleScroll);
        } else {
            window.removeEventListener("scroll", handleScroll);
        }
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container ".concat((products_module_default())["home-product-container"]),
        children: [
            handleBlockTitle["".concat(!!products.length)]["".concat(!!((ref1 = products[0]) === null || ref1 === void 0 ? void 0 : ref1.block_title))],
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (products_module_default())["block-products__body"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (products_module_default())["block-products__list"],
                    children: (isMobile && !originalProducts ? products.filter(function(_, indexFil) {
                        return indexFil < 2;
                    }) : products).map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                minHeight: 200
                            },
                            className: (products_module_default())["product-card-parent"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: !originalProducts ? ref2 : null,
                                className: (products_module_default())["block-products__list-item"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                                    isMobile: true,
                                    product: product,
                                    priority: false,
                                    loading: "lazy"
                                }, pageProps))
                            })
                        }, product.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var BlockProduct_ThirdProducts = (ThirdProducts);

// EXTERNAL MODULE: ./components/shared/ReCaptchaWrapper.tsx
var ReCaptchaWrapper = __webpack_require__(2598);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./pages/index.tsx
















var Home = function(pageProps) {
    var sliderData = pageProps.sliderData, newProducts = pageProps.newProducts, featuredProducts = pageProps.featuredProducts, thirdSectionProducts = pageProps.thirdSectionProducts, _metas = pageProps.metas, _meta_title = _metas.meta_title, meta_title = _meta_title === void 0 ? "" : _meta_title, _meta_description = _metas.meta_description, meta_description = _meta_description === void 0 ? "" : _meta_description, _meta_keywords = _metas.meta_keywords, meta_keywords = _meta_keywords === void 0 ? "" : _meta_keywords, _share_pic = _metas.share_pic, share_pic = _share_pic === void 0 ? "" : _share_pic, dbName = pageProps.dbName, domain = pageProps.domain, translationsData = pageProps.translationsData, backOrderValue = pageProps.backOrderValue, _currencies = pageProps.currencies, currencies = _currencies === void 0 ? [] : _currencies, _selectedLocale = pageProps.selectedLocale, selectedLocale = _selectedLocale === void 0 ? "" : _selectedLocale, getBuilderData = pageProps.getBuilderData, showBuilderData = pageProps.showBuilderData, isMobile = pageProps.isMobile, showSlider = pageProps.showSlider, showThirdSection = pageProps.showThirdSection, recaptchaActive = pageProps.recaptchaActive, recaptchaKey = pageProps.recaptchaKey, siteName = pageProps.siteName, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales;
    var router = (0,next_router.useRouter)();
    var _currencies1 = (0,_sliced_to_array/* default */.Z)(currencies, 1), tmp = _currencies1[0], ref = tmp === void 0 ? {} : tmp, tmp1 = ref.code, selectedCurrCode = tmp1 === void 0 ? "" : tmp1, tmp2 = ref.symbol, selectedCurrSymbol = tmp2 === void 0 ? "" : tmp2, tmp3 = ref.exchange_rate, ref1 = tmp3 === void 0 ? {} : tmp3, tmp4 = ref1.rate, selectedCurrRate = tmp4 === void 0 ? "1" : tmp4;
    var builderProps = {
        getBuilderData: getBuilderData,
        domain: domain,
        dbName: dbName,
        translationsData: translationsData,
        selectedLocale: selectedLocale,
        currencies: currencies,
        backOrderValue: backOrderValue,
        selectedCurrItems: {
            selectedCurrCode: selectedCurrCode,
            selectedCurrRate: selectedCurrRate,
            selectedCurrSymbol: selectedCurrSymbol
        },
        isMobile: isMobile,
        recaptchaActive: recaptchaActive,
        showAllBuilderComponents: newProducts.length <= 1 && featuredProducts.length <= 1
    };
    var showBuilderComponents = function(id) {
        return {
            "true": /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderDataRender/* default */.Z, (0,_object_spread/* default */.Z)({
                tab: id,
                lcpElement: showSlider === "Empty" && id === 1
            }, builderProps)),
            "false": null
        };
    };
    var productProps = {
        selectedLocale: selectedLocale,
        dbName: dbName,
        translationsData: translationsData,
        backOrderValue: backOrderValue,
        selectedCurrItems: {
            selectedCurrCode: selectedCurrCode,
            selectedCurrRate: selectedCurrRate,
            selectedCurrSymbol: selectedCurrSymbol
        },
        isMobile: isMobile
    };
    var ShowThirdSection = {
        "ThirdSection": /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockProduct_ThirdProducts, (0,_object_spread/* default */.Z)({
                    products: thirdSectionProducts
                }, productProps)),
                showBuilderComponents(4)["".concat(showBuilderData)]
            ]
        }),
        "Empty": null
    };
    var ShowSlider = {
        "Slider": /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
            slider: sliderData,
            dbName: dbName,
            translationsData: translationsData
        }),
        "Empty": null
    };
    var canonicalUrl = "".concat(dbName).concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? "/" + selectedLocale : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptchaWrapper/* default */.Z, {
        recaptchaActive: recaptchaActive,
        recaptchaKey: recaptchaKey,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: meta_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "title",
                                content: meta_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: meta_description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "keywords",
                                content: meta_keywords
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "generator",
                                content: "Zegashop.com"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "robots",
                                content: "index, follow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: meta_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: meta_description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:keywords",
                                content: meta_keywords
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain).concat(share_pic))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: meta_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: meta_description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:keywords",
                                content: meta_keywords
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain).concat(share_pic))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:url",
                                content: (0,helper/* domainUrl */.HJ)(canonicalUrl)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:locale",
                                content: selectedLocale
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:site_name",
                                content: siteName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "canonical",
                                href: (0,helper/* domainUrl */.HJ)(canonicalUrl)
                            }),
                            (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)(dbName),
                                        hrefLang: "x-default"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)(dbName),
                                        hrefLang: defaultLangCode
                                    }),
                                    locales.map(function(intl) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                            rel: "alternate",
                                            href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code)),
                                            hrefLang: intl.code
                                        });
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    ShowSlider[showSlider],
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                        translationsData: translationsData
                    }),
                    showBuilderComponents(1)["".concat(showBuilderData)],
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockProduct_NewProducts, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        products: newProducts
                    }, productProps), {
                        showSlider: showSlider
                    })),
                    showBuilderComponents(2)["".concat(showBuilderData)],
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockProduct_FeaturedProducts, (0,_object_spread/* default */.Z)({
                        products: featuredProducts
                    }, productProps)),
                    showBuilderComponents(3)["".concat(showBuilderData)],
                    ShowThirdSection[showThirdSection]
                ]
            })
        }))
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 66445:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"home_slide_container":"BlockSlideShow_home_slide_container__BiQv_","block-slideshow__slide-image":"BlockSlideShow_block-slideshow__slide-image__4LywK","block-slideshow__slide":"BlockSlideShow_block-slideshow__slide__HpQ_w","slider_image_wrapper":"BlockSlideShow_slider_image_wrapper__g1z0R","block-slideshow__slide-image--desktop":"BlockSlideShow_block-slideshow__slide-image--desktop__ZhH72","block-slideshow__slide-image--mobile":"BlockSlideShow_block-slideshow__slide-image--mobile__UU1Pd","block-slideshow__body":"BlockSlideShow_block-slideshow__body__1Dwt_","block-slideshow__slide-button":"BlockSlideShow_block-slideshow__slide-button__DMiZd","block-slideshow__slide-title":"BlockSlideShow_block-slideshow__slide-title__6Se_3","block-slideshow__slide-content":"BlockSlideShow_block-slideshow__slide-content__GGClE","block-slideshow__slide-text":"BlockSlideShow_block-slideshow__slide-text__mpbDo","block-slideshow":"BlockSlideShow_block-slideshow__WYCpQ","correct-slick-active":"BlockSlideShow_correct-slick-active__ROpPO","slideshow-btn":"BlockSlideShow_slideshow-btn__IzPZD","block-slideshow--layout--with-departments":"BlockSlideShow_block-slideshow--layout--with-departments__sNh_b","btn":"BlockSlideShow_btn__R48e0","btn-svg-icon":"BlockSlideShow_btn-svg-icon__7s0lV"};

/***/ }),

/***/ 67157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"welcome-title":"homePage_welcome-title__ePhjB"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,6033,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);